<template>
<div class="grid"  @click="edit">


<template v-if="editing">

<div class="col-12">



<div class="grid mt-2"  v-click-away="cancel">
<div class="col">

<Dropdown v-model="inputdata" :options="options" optionLabel="name" optionValue="id" class="w-full p-inputtext-sm"   @change="submitChanges" :filter="showfilter"/>

</div>
</div>
</div>
</template>

<template v-if="!editing">	
<div  class="col-12">
<p class="click_edit_value">
{{returnvalue.name}}
</p>
</div>
</template>

</div>	
</template>

<script>
export default {

  name: 'UserLanguageSwitcher',
  props:["title","value","valkey","options","hide_label","filter"],
  data () {
    return {
    	editing:false,
    	inputdata:null,
    }
  },
  computed:{
    showfilter()
    {
      if(this.filter)
      {
        return true
      }
      else
      {
        return false
      }
    },
    inputareaclass()
    {
      if(this.hide_label)
      {
        return "col-9 md:col-12 mt-0"
      }
      else
      {
        return "col-9 md:col-10 mt-0"
      }
    },
    returnvalue()
    {
      
      if(this.value)
      {
        let selected = this.options.find((item)=>{return item.id == this.value})
        if(!selected)
        {
          return this.value
        }
        return selected
      }
      else
      {
        return {name:null,id:null}
      }
      
    }
  },
  watch:{
  	value(nevVal,oldVal)
  	{
  		  if(this.value===0)
          {this.inputdata=null}
  		 this.editing = false
  	}
  },
  methods:{
  	submitChanges()
  	{
      
  		if(this.inputdata !==this.value)
  		{
  			this.$emit("dataChanged",{value:this.inputdata,key:this.valkey})
  			//this.cancel()
  		}
  		else
  		{
  			this.cancel()
  		}
  		
  	},
  	edit()
  	{
  		this.editing = true
  		this.inputdata = this.value
  		
  		setTimeout(()=>{
  			if(this.$refs.inputarea)
  			{
  				this.$refs.inputarea.$el.focus()
  			}
  			
  		},10)
  		
  	},
  	cancel()
  	{
  		setTimeout(()=>{
  			this.editing = false
  		},10)
  		
  	},

  }
};
</script>

<style lang="css" scoped>
</style>